const FormMode = {
	Add: 1,
	Edit: 2,
	Vỉew: 3,
	Delete: 4
}
export default FormMode;